// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoType } from './contactInfoType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class BasicEnrollmentPointOfContact {
    'firstName'?: string;
    'lastName'?: string | null;
    'jobTitle'?: string | null;
    'phoneNumber'?: string | null;
    'phoneNumberExtension'?: string | null;
    'faxNumber'?: string | null;
    'emailAddress'?: string | null;
    'preferredContactMethod'?: ContactInfoType;
    'officeContactNote'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof BasicEnrollmentPointOfContact>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "jobTitle",
            "baseName": "jobTitle",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "phoneNumberExtension",
            "baseName": "phoneNumberExtension",
            "type":     "string"
        },
        {
            "name":     "faxNumber",
            "baseName": "faxNumber",
            "type":     "string"
        },
        {
            "name":     "emailAddress",
            "baseName": "emailAddress",
            "type":     "string"
        },
        {
            "name":     "preferredContactMethod",
            "baseName": "preferredContactMethod",
            "type":     "ContactInfoType"
        },
        {
            "name":     "officeContactNote",
            "baseName": "officeContactNote",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return BasicEnrollmentPointOfContact.attributeTypeMap;
    }
}
